/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;

/**
 * Prevent zone.js from intercepting high-frequency events that don't need
 * to trigger Angular change detection. Scroll and pointer-move events fire
 * dozens of times per second; running a full CD cycle on each one causes
 * forced reflows. Event listeners that DO need CD (e.g. Ionic's ionScroll)
 * can call NgZone.run() explicitly.
 */
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove', 'pointermove', 'touchmove'];
